<template lang="html">
    <div class="test">
            <v-flex xs12 class="text-xs-right">
                    <div class="actions">
                        <v-btn round outline color="primary" @click="createProduct()" small class="normal" v-if="$store.state.auth.user.level >= 60">
                            <v-icon left color="primary">add_circle</v-icon>
                            Lier un produit Sidamo
                        </v-btn>
                    </div>
            </v-flex>

            <v-layout wrap row>
                <v-flex xs12 md6 lg3 v-for="(product, index) in sidamo_products" :key="product.id">
                    <v-card class="product-card" :class="{'selected-card' : selected === product.id}" >
                        <v-card-media @click="openProduct(product.id, index, 'sidamo')">
                             <v-layout row justify-center>
                                <img :class="{'have-product-img' : product.photo !== null}" :src="product.photo === null ? require('../../../assets/img/defaultProduct.png') : product.photo"/>
                            </v-layout>
                        </v-card-media>
                        <v-card-title secondary-title @click="openProduct(product.id, index, 'sidamo')">
                          <div>
                            <p class="product-label mb-0">{{product.label}}</p>
                            <p class="product-supplier">
                              <template v-if="product.supplier">
                                {{product.supplier.name}}
                              </template>
                              <template v-else-if="product.category">
                                {{product.category.label}}
                              </template>
                            </p>
                          </div>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn icon small @click="goToProduct(product.id, product.group)"><v-icon small>open_in_new</v-icon></v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
    </div>
</template>

<script>
import { ProductTypes } from '../../../config/enum/ProductTypes.js'
import { CommentTypes } from '../../../config/enum/CommentTypes.js'
import DeleteProduct from './DeleteProduct'
import ProductAside from './ProductAside'
import AddSidamoProduct from './AddSidamoProduct.vue'

export default {
	data() {
		return {
            selected: null
		}
	},
	computed: {
		sidamo_products: function() {
			return this.$store.state.single.data.sidamo_products;
		},
	},
	methods: {
		createProduct: function() {
			this.$eventHub.$emit('open-modal', AddSidamoProduct);
		},

        openProduct: function(productId, productIndex, productType) {
            if (this.selected === productId) {
                this.$eventHub.$emit('close-aside');
            } else {
                this.$eventHub.$emit('close-aside');
                this.$eventHub.$emit('open-aside', ProductAside, {
                    product_id: productId,
                    product_index: productIndex,
                    product_type: productType
                });
                this.selected = productId;
            }
        },

        closeProduct: function (){
            this.selected = null;
        },

        goToProduct: function(productId, groupLabel) {
            this.$router.push({ name: 'single-product', params: { id: productId, group: groupLabel } })
        },
	},
  created() {
    this.$eventHub.$on('close-aside', () => {
      this.selected = null
    })
  },
    beforeDestroy(){
        this.$eventHub.$emit('close-aside');
    }
}
</script>

<style lang="stylus" scoped>
@require '../../../assets/css/variables'
div.layout {
    & > div.flex {
        max-width: 240px;
    }
}
div.product-card {
  margin: 0 20px 20px 0
  border-radius: 6px
  background-color: $app-nav-background
  box-shadow: 0 8px 26px 0 $box-shadow-color
  cursor: pointer

    .card__media .card__media__content .layout {
        height:180px

        img {
            padding:10px
            width:180px
            height:180px

            &.have-product-img {
                width: 100%
                height: auto
                padding: 0
                object-fit: contain
            }
        }
    }

  .card__title {
    padding: 14px 14px 10px 14px
    .product-label {
      font-weight: 700
      font-size:16px
    }

    .product-supplier {
      color:#707D90
      height:1.4rem
      margin: 0 0 14px 0
    }
  }

  & >>> hr.divider {
    background-color: #E7EDF3
  }


  .comments-indicator {
    font-weight:700
    .icon {
      font-size: 12px
    }

  }

  &.selected-card {

    .card__title, .card__actions {
      background-color : $primary-color
      color:#fff
      & >>> .product-supplier {
              color:white;
            }
      }

    }

    & >>> hr.divider {
      background-color: #E7EDF3
    }
}

</style>



// WEBPACK FOOTER //
// src/views/projects/single/Sidamos.vue